import script from "./Menu.vue?vue&type=script&setup=true&lang=ts"
export * from "./Menu.vue?vue&type=script&setup=true&lang=ts"

import "./Menu.vue?vue&type=style&index=0&id=102ce8c8&scoped=true&lang=css"
script.__scopeId = "data-v-102ce8c8"

export default script